import { render, staticRenderFns } from "./DkBadge.vue?vue&type=template&id=f1f099ac&"
import script from "./DkBadge.vue?vue&type=script&lang=js&"
export * from "./DkBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports